<template>
  <div>

    <b-container class="self-assesment">
      <div class="box">
        <b-row>
          <b-col xl="10" offset-xl="1">
            <h2>{{ $t("label_selfAssessment_submitReview_title") }}</h2>
            <p>{{ $t("label_selfAssessment_submitReview_description") }}</p>
            <p>
              <input
                id="selfAssessment_laborConditions_leavePolicies_paternity_policyExists"
                v-model="submitReviewDisclaimer"
                type="checkbox"
                :true-value="true"
                :false-value="false"
              />
              {{ $t("label_selfAssessment_submitReview_disclaimer") }}
            </p>
            <p v-if="average < 100">
              <input
                id="label_selfAssessment_acceptance_missing_information"
                v-model="acceptanceMissingInformation"
                type="checkbox"
                :true-value="true"
                :false-value="false"
              />
              {{ $t("label_selfAssessment_acceptance_missing_information") }}
            </p>
            <p
              v-if="average < 100 && !acceptanceMissingInformation"
              class="error"
            >
              {{ $t("label_selfAssessment_submitReview_incomplete") }}
            </p>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="6" offset-lg="3">
            <b-button
              variant="primary"
              block
              :disabled="
                !(
                  (average >= 100 || acceptanceMissingInformation) &&
                  submitReviewDisclaimer
                )
              "
              @click="sendForReview()"
            >
              {{ $t("label_selfAssessment_submitReview_button") }}
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-container>
    <b-modal
      id="modalInfo"
      v-model="showModal"
      modal-class="modalInfo"
      :title="$t('label_selfAssessment_submitReview_modal_title')"
    >
      <p>{{ $t("label_selfAssessment_submitReview_modal_description") }}</p>
      <div slot="modal-footer" class="w-100">
        <b-btn variant="primary" @click="okModal()">
          {{ $t("label_selfAssessment_submitReview_modal_confirmation") }}
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "SelfAssessmentSubmitReview",
  data: function () {
    return {

      submitReviewDisclaimer: false,
      acceptanceMissingInformation: false,
      categories: [
        "general",
        "staff",
        "laborConditions",
        "humanResources",
        "employmentPolicies",
      ],
      average: false,
      error: "",
      showModal: false,
    };
  },
  created: function () {
    if (
      this.getCurrentSnapshot.status !== "label_configuration_snapshot_active"
    ) {
      this.$router.push("/home");
    }
    // Varify categories
    var sum = 0;
    for (var i in this.categories) {
      sum = sum + this.getSelfAssessmentAdvance(this.categories[i]);
    }
    this.average = sum / 5;
  },
  methods: {
    sendForReview: function () {
      this.error = "";
      this.openModal();
    },
    openModal() {
      this.showModal = true;
    },
    async okModal() {
      this.showModal = false;
      await this.$store.dispatch("SELF_SNAPSHOT_SEND_TO_VALIDATE").catch(() => {
      });
      await this.$store.dispatch("SNAPSHOTS_GET").catch(() => {
      });
      await this.$router.push("/home");
    },
  },
  computed: {
    ...mapGetters({
      selfAssessment: "getSelfAssessment",
      statusSelfAssessment: "getSelfAssessmentStatus",
      getSelfAssessmentAdvance: "getSelfAssessmentAdvance",
      getCurrentSnapshot: "getCurrentSnapshot",
    }),
  },
};
</script>

<style lang="sass" scoped>

p
  text-align: center
</style>
